import { YesOrNoModel } from 'forms/shared/types';

export const EmptyBranch = (name = ''): YesOrNoModel => ({
  value: '',
  name,
});

export const EmptyBranchInstance = EmptyBranch();
